import React, {
  createContext,
  useContext,
  ReactNode,
  SetStateAction,
} from 'react';

import {
  type PartSetupState,
  type PartSetupStateChanges,
  usePartSetupState,
} from 'modules/viewerPage/apps/quotePartViewerApps/partSetup/utils/partSetupState';

interface QuotePartViewerContextProps {
  state: PartSetupState;
  setState: SetStateAction<PartSetupStateChanges>;
}

const QuotePartViewerContext = createContext<
  QuotePartViewerContextProps | undefined
>(undefined);

export const QuotePartViewerProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [state, setState] = usePartSetupState();

  return (
    <QuotePartViewerContext.Provider value={{ state, setState }}>
      {children}
    </QuotePartViewerContext.Provider>
  );
};

export const useQuotePartViewerContext = (): QuotePartViewerContextProps => {
  const context = useContext(QuotePartViewerContext);
  if (!context) {
    throw new Error(
      'useQuotePartViewerContext must be used within a QuotePartViewerProvider',
    );
  }
  return context;
};
